import React from 'react'
import { isNil, truncate } from 'lodash'
import Tooltip from './Tooltip'

function JsonDisplay(value) {
  if (isNil(value)) { return null }

  const title = truncate(JSON.stringify(value), { length: 30 })
  const content = JSON.stringify(value, null, 2)

  return (
    <Tooltip title={title}>
      <code><pre>{content}</pre></code>
    </Tooltip>
  )
}

export default JsonDisplay
